/* PROJ-96 V5 (20.10.2026): Personalisierung der Fußabdruck Kette auf der PDP (snippets/abdruck-pdp.liquid).
   =========================================================================================================
   Muster Besties-Shirt (assets/besties-shirt.js, PROJ-67), Ansage Dominik 20.10.:
     - Startfrage „Hast du schon einen Fußabdruck?“ (Ja/Nein) ist Pflicht; erst danach klappen die Felder auf und
       die Vorschau-Bühne wandert in die Galerie (mountStageInGallery/fixiereGalerie wie beim Shirt).
     - Gekauft wird über das Warenkorb-Formular des Themes: Submit in der Capture-Phase abfangen, prüfen, Felder
       markieren (markiereFehler), versteckte Properties setzen (setProp), zweiter Durchlauf geht durch.
   Vorschau = jewelry-abdruck-engine.js (dieselbe Geometrie wie der Laser) mit dem Beispiel-Fuß; das Foto der
   Kundin erscheint nie (Dominik 20.10.: „Er soll denken: Wir bearbeiten das.“).
   Verbesserungen gegenüber besties-shirt.js:
     - Zustand auf window: der Varianten-Wechsel baut die Buy Box neu auf und führt dieses Script erneut aus
       (gemessen 20.10.), die Eingaben bleiben stehen.
     - Variante direkt aus dem Theme-Formular statt Such-Schleife; Galerie-Slide aus featured_media der Variante.
     - Bühne als Vorlage im DOM (data-apdp-stage-source), Duplikate nach Re-Render werden entfernt (stageEl).
   Config: produkt abdruck-coin, quelle 'pdp', abdruck 'ausstehend', pfad_url null, schrift, foto_url wenn da. */
(function () {
  'use strict';
  /* 25.10.2026 (Dominik: „bei der Sternenkarte kannst du ja wirklich die Straße eingeben“): Adressen und Orte von
     Interesse (address, poi) wie in der Sternkarten-Suche, nicht nur Städte. Bei einer Adresse heißt der Ort
     „Straße Nr, Stadt“; zu lang für das Format Ortsname = die Engine graviert die Koordinaten (ortnameZuLang). */
  function ortLabel(f) {
    const typ = (f.place_type || [])[0];
    if (typ !== 'address' && typ !== 'poi') return f.text;
    const nr = typ === 'address' && f.address ? ' ' + f.address : '';
    const stadt = ((f.context || []).find(c => /^place\./.test(c.id)) || {}).text;
    return f.text + nr + (stadt ? ', ' + stadt : '');
  }

  const ENGINE = window.JEWELRY_ABDRUCK;
  if (!ENGINE || typeof window.jewelryAbdruckFrontSVG !== 'function' || typeof window.jewelryFontDefs !== 'function') {
    console.error('[abdruck-pdp] jewelry-engine.js / jewelry-abdruck-engine.js nicht geladen');
    return;
  }
  /* Die Buy Box wird beim Farbwechsel neu aufgebaut. Statt auf das erneute Laden dieses Scripts zu warten (ohne Cache
  Sekunden, so lange stand das Panel zugeklappt da; Dominik 20.10.), richtet ein MutationObserver jede neue Box sofort ein,
  noch vor dem nächsten Bild. Das neu eingefügte Script ruft nur noch starte(). */
  if (window.__dlAbdruckPdpStart) { window.__dlAbdruckPdpStart(); return; }
  function starte() {
    const root = document.querySelector('[data-abdruck-pdp]:not([data-apdp-bereit])');
    if (!root) return;
    root.setAttribute('data-apdp-bereit', '');
    let CFG;
    try { CFG = JSON.parse(root.querySelector('[data-abdruck-pdp-cfg]').textContent); } catch (e) {
      console.error('[abdruck-pdp] Konfiguration fehlt', e);
      return;
    }
    const $ = (sel) => root.querySelector(sel);
    const SCHRIFTEN = window.JEWELRY_ABDRUCK_SCHRIFTEN || {};
    const FORM = CFG.form === 'herz' ? 'herz' : 'coin';
    const MODERN = ENGINE.SCHRIFT_STANDARD || 'modern';
    const API = 'https://tiles.distantlines.de';
    const MAX_DATEI_MB = 20, FOTO_MAX = 2400, FOTO_LAUF_MS = 60000, FOTO_WARTEN_MS = 30000, VORSCHAU_MS = 4000;
    const BEISPIEL_BOGEN = { oben: '22.04.2025 · 19:05 Uhr', unten: '3220 g · 52 cm' };
    const BEISPIEL_RUECK = 'Für immer an deiner Seite';
    const RUECK_MAX = ENGINE.RUECKSEITE_MAX || 60;
    const RUECK_PFAD = ENGINE.RUECK_MOTIVE_PFAD || ['handschrift', 'fingerabdruck'];
    const RUECK_KACHELN = [
      ['keine', 'Keine'], ['text', 'Text'], ['handschrift', 'Handschrift'], ['fingerabdruck', 'Fingerabdruck'],
      ['blume', 'Geburtsblume'], ['sternenhimmel', 'Sternenhimmel'], ['koordinaten', 'Koordinaten'],
    ];
    const RUECK_GRAVUR = { handschrift: ENGINE.GRAVUR_FLAECHE, fingerabdruck: ENGINE.GRAVUR_LINIEN };
    const BEISPIEL_ORT = { name: 'Braunschweig', lat: 52.2689, lon: 10.5268 };
    const BEISPIEL_DATUM = '2025-04-22';

    /* ---------------- Zustand (überlebt den Neuaufbau der Buy Box) ---------------- */
    const SP = window.__dlAbdruckPdp || (window.__dlAbdruckPdp = { state: null, lauscher: false, inst: null });
    const schriften = (CFG.schriften || [MODERN]).filter((k) => k === MODERN || SCHRIFTEN[k]);
    if (!schriften.length) schriften.push(MODERN);
    const state = SP.state || (SP.state = {
      start: null,                 /* 'ja' | 'nein' */
      set: false,                  /* Abdruck-Set als eigene Position dazu (nur bei 'nein', nie vorausgewählt) */
      schrift: schriften[0],
      geburt: { datum: '', zeit: '', gewicht: '', groesse: '' },
      rueck: '',
      /* Rückseite (Dominik 20.10.): Motiv aus RUECK_MOTIVE, ohne Aufpreis. Foto bei Handschrift/Fingerabdruck optional
         (sonst Upload-Link nach dem Kauf), Ort für Sternenhimmel und Koordinaten, Blume aus dem Geburtsmonat. */
      rueckMotiv: 'keine',
      rueckFoto: null,             /* { name, lauf, url, fertig } wie foto */
      rueckOrt: null,              /* { name, lat, lon } */
      rueckBlume: '',
      foto: null,                  /* { name, lauf, url, fertig } */
      seite: 'front',
      beispielD: '',
      fehlerAktiv: false,
      vorbereitet: null,
    });
    if (schriften.indexOf(state.schrift) < 0) state.schrift = schriften[0];

    /* ---------------- Schriften ---------------- */
    const schriftLabel = (k) => (k === MODERN ? 'Modern' : SCHRIFTEN[k].label);
    const schriftFamilie = (k) => (k === MODERN ? "'DL Gravur'" : "'" + SCHRIFTEN[k].familie + "'");
    if (!document.getElementById('apdp-faces')) {
      let css = '';
      const m = /<style>([\s\S]*?)<\/style>/.exec(window.jewelryFontDefs() || '');
      if (m) css += m[1];
      for (const k of schriften) if (k !== MODERN) css += "@font-face{font-family:'" + SCHRIFTEN[k].familie + "';src:url(data:font/woff2;base64," + SCHRIFTEN[k].woff2 + ") format('woff2');font-display:block;}";
      const st = document.createElement('style');
      st.id = 'apdp-faces';
      st.textContent = css;
      document.head.appendChild(st);
    }
    const kachelBox = $('[data-apdp-schriften]');
    for (const k of schriften) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'apdp-schrift';
      b.setAttribute('role', 'radio');
      b.dataset.schrift = k;
      /* Dominik 23.10.: in jeder Kachel dasselbe Probewort in der jeweiligen Schrift, keine beschreibenden Namen
         (Modern, Klassisch …) mehr; der Schriftname bleibt nur für Screenreader. */
      b.innerHTML = '<span class="apdp-schrift__probe"></span>';
      b.firstChild.textContent = 'Emma';
      b.firstChild.style.fontFamily = schriftFamilie(k);
      b.setAttribute('aria-label', schriftLabel(k));
      b.addEventListener('click', () => { state.schrift = k; geaendert(); });
      kachelBox.appendChild(b);
    }

    /* ---------------- Variante + Theme-Formular ---------------- */
    const VARIANTEN = CFG.varianten || {};
    function istUnserFormular(f) {
      const id = f && f.querySelector('[name="id"]');
      return !!(id && VARIANTEN[String(id.value)]);
    }
    function themeForm() {
      const alle = document.querySelectorAll('form[action*="/cart/add"]');
      for (const f of alle) if (istUnserFormular(f)) return f;
      return null;
    }
    function varianteId() {
      const f = themeForm();
      return f ? String(f.querySelector('[name="id"]').value) : Object.keys(VARIANTEN)[0];
    }
    const farbe = () => (/gold/.test((VARIANTEN[varianteId()] || {}).farbe || '') ? 'gold' : 'silber');
    function setProp(f, name, wert) {
      const feld = 'properties[' + name + ']';
      let inp = f.querySelector('input[name="' + feld + '"][data-apdp]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = feld;
        inp.setAttribute('data-apdp', '');
        f.appendChild(inp);
      }
      inp.value = wert;
    }

    /* ---------------- Gates (1:1 jewelry-abdruck.js) ---------------- */
    function datumDe(iso) {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
      return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
    }
    function bogenTexte() {
      const g = state.geburt;
      return {
        oben: [datumDe(g.datum), g.zeit ? g.zeit + ' Uhr' : ''].filter(Boolean).join(' · '),
        unten: [g.gewicht ? parseInt(g.gewicht, 10) + ' g' : '', g.groesse ? parseInt(g.groesse, 10) + ' cm' : ''].filter(Boolean).join(' · '),
      };
    }
    function geburtProblem() {
      const g = state.geburt;
      const heute = new Date().toISOString().slice(0, 10);
      if (g.datum && (!/^\d{4}-\d{2}-\d{2}$/.test(g.datum) || g.datum > heute || g.datum < '1900-01-01')) return 'Bitte ein gültiges Geburtsdatum eingeben (nicht in der Zukunft).';
      if (g.zeit && !/^\d{2}:\d{2}$/.test(g.zeit)) return 'Bitte die Uhrzeit als HH:MM eingeben.';
      if (g.gewicht !== '' && !(/^\d{3,4}$/.test(String(g.gewicht)) && +g.gewicht >= 300 && +g.gewicht <= 9999)) return 'Bitte das Gewicht in Gramm eingeben (300 bis 9999).';
      if (g.groesse !== '' && !(/^\d{2}$/.test(String(g.groesse)) && +g.groesse >= 20 && +g.groesse <= 99)) return 'Bitte die Größe in cm eingeben (20 bis 99).';
      const b = bogenTexte();
      if (window.jewelryAbdruckRingZuLang(b.oben, b.unten, state.schrift)) return 'Die Geburtsdaten passen in dieser Schrift nicht auf den Ring.';
      return null;
    }
    const RUECK_ALLOWED = /^[ -~¡-¬®-±´¶-¸º-»¿-ĬĮ-ıĴ-ňŌ-žȘ-țˆ-ˇ˘-˝ΔΩЁЃЌЎА-яёѓќўẀ-ẅỲ-ỳ–-—‘-‚“-„†-•…‰‹-›⁄€™∂∏∑√∞∫≈≠≤-≥◊]*$/;
    const RUECK_EMOJI = /\p{Extended_Pictographic}|[\u{1F1E6}-\u{1F1FF}]|️/u;
    /* Rückseiten-Text mit eigenen Zeilen (Enter, Dominik 21.10.): Zeilen bleiben erhalten, leere fallen weg */
    const ZEILEN_MAX = ENGINE.TEXT_ZEILEN_MAX || 4;
    const rueckZeilen = () => state.rueck.split(/\r?\n/).map((z) => z.trim().replace(/\s+/g, ' ')).filter(Boolean);
    const rueckNorm = () => rueckZeilen().join('\n');
    const rueckZeichen = () => [...rueckZeilen().join('')].length;
    function rueckProblem() {
      if (state.rueckMotiv !== 'text') return null;
      const zeilen = rueckZeilen();
      if (!zeilen.length) return null;
      const t = zeilen.join(' ');
      if (RUECK_EMOJI.test(t)) return 'Emojis können nicht graviert werden, bitte nur Text.';
      if (!RUECK_ALLOWED.test(t) || !window.jewelryAbdruckTextInSchrift(t, state.schrift)) return 'Der Text enthält Zeichen, die wir in dieser Schrift nicht gravieren können.';
      if (zeilen.length > ZEILEN_MAX) return 'Bitte höchstens ' + ZEILEN_MAX + ' Zeilen.';
      if (rueckZeichen() > RUECK_MAX) return 'Der Text ist zu lang, maximal ' + RUECK_MAX + ' Zeichen.';
      if (window.jewelryAbdruckTextZuLang(rueckNorm(), state.schrift)) return 'Der Text passt nicht auf den Anhänger, bitte kürzen.';
      return null;
    }
    /* Pflicht und Gültigkeit je Feld (data-feld) -> Liste der Schlüssel, die fehlen oder falsch sind */
    function fehlendeFelder() {
      const keys = [];
      if (!state.start) { keys.push('start'); return keys; }
      if (state.start === 'ja' && !(state.foto && state.foto.url !== null)) keys.push('foto');
      /* Alle vier Geburtsdaten sind Pflicht (Dominik 20.10.: Uhrzeit, Gewicht, Größe ließen sich leer in den Warenkorb legen) */
      ['datum', 'zeit', 'gewicht', 'groesse'].forEach((k) => { if (state.geburt[k] === '' || state.geburt[k] == null) keys.push(k); });
      const pg = geburtProblem();
      const pk = pg && (/Gewicht/.test(pg) ? 'gewicht' : /Größe/.test(pg) ? 'groesse' : /Uhrzeit/.test(pg) ? 'zeit' : 'datum');
      if (pk && keys.indexOf(pk) === -1) keys.push(pk);
      if (rueckProblem()) keys.push('rueck-text');
      const m = state.rueckMotiv;
      if (m === 'text' && !rueckNorm()) keys.push('rueck-text');
      if ((m === 'sternenhimmel' || m === 'koordinaten') && !state.rueckOrt) keys.push('rueck-ort');
      if (RUECK_PFAD.indexOf(m) >= 0 && state.rueckFoto && state.rueckFoto.fertig && !state.rueckFoto.url) keys.push('rueck-foto');
      return keys;
    }

    /* ---------------- Rückseiten-Motive: Daten erst bei Bedarf laden ----------------
       Blumen-Motive (~800 KB) und Sterndaten (~650 KB) braucht nur, wer das Motiv antippt. Caches auf SP, damit der
       Neuaufbau der Buy Box nichts doppelt lädt. Die Vorschau zeigt bei Handschrift und Fingerabdruck wie vorne ein
       Beispiel, nie das Foto der Kundin. */
    function skriptLaden(url) {
      return new Promise((res, rej) => {
        const sc = document.createElement('script');
        sc.src = url;
        sc.onload = res;
        sc.onerror = rej;
        document.head.appendChild(sc);
      });
    }
    function ladeBlumen() {
      if (typeof window.jewelryBlumenFrontSVG === 'function') return Promise.resolve(true);
      if (!SP.blumenLauf) {
        SP.blumenLauf = skriptLaden(CFG.blumenMotiveUrl).then(() => skriptLaden(CFG.blumenEngineUrl)).then(() => true)
          .catch(() => { SP.blumenLauf = null; return false; });
      }
      return SP.blumenLauf;
    }
    function ladeSterne() {
      if (SP.sterne) return Promise.resolve(true);
      if (!SP.sterneLauf) {
        SP.sterneLauf = Promise.all(['/stars.6.json', '/constellations.lines.json'].map((n) => fetch(CFG.sternDatenBasis + n).then((r) => r.json())))
          .then(([sterne, linien]) => { SP.sterne = { sterne, linien }; return true; })
          .catch(() => { SP.sterneLauf = null; return false; });
      }
      return SP.sterneLauf;
    }
    function ladeBeispiel(motiv) {
      SP.beispiele = SP.beispiele || {};
      if (SP.beispiele[motiv] != null) return Promise.resolve(true);
      const url = motiv === 'handschrift' ? CFG.beispielHandschriftUrl : CFG.beispielFingerabdruckUrl;
      return fetch(url, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : null)).then((j) => {
        const d = j && typeof j.d === 'string' ? j.d : '';
        SP.beispiele[motiv] = d && window.jewelryAbdruckPfadOk(d, { gravur: RUECK_GRAVUR[motiv] }).ok ? d : '';
        return true;
      }).catch(() => false);
    }
    function motivVorbereiten(m) {
      const lauf = m === 'blume' ? ladeBlumen() : m === 'sternenhimmel' ? ladeSterne()
        : RUECK_PFAD.indexOf(m) >= 0 ? ladeBeispiel(m) : null;
      if (lauf) lauf.then(() => { if (SP.inst) SP.inst.geaendert(); });
    }
    const geburtsMonat = () => {
      const m = /^\d{4}-(\d{2})-\d{2}$/.exec(state.geburt.datum || '');
      return m ? parseInt(m[1], 10) : 0;
    };
    function blumenListe() {
      return typeof window.jewelryBlumenFuerMonat === 'function' ? window.jewelryBlumenFuerMonat(geburtsMonat() || 4) : [];
    }
    function blumeAktuell() {
      const liste = blumenListe();
      return liste.indexOf(state.rueckBlume) >= 0 ? state.rueckBlume : (liste[0] || '');
    }
    /* Engine-Config der Rückseite; vorschau = fehlende Angaben durch Beispiele ersetzen (wie der Ring vorne) */
    function rueckCfg(vorschau) {
      const m = state.rueckMotiv;
      const c = { form: FORM, schrift: state.schrift, rueck_motiv: m };
      if (m === 'text') {
        const t = rueckNorm();
        c.rueckseite = vorschau && (!t || rueckProblem()) ? BEISPIEL_RUECK : t;
      }
      if (RUECK_PFAD.indexOf(m) >= 0) c.rueck_gravur = RUECK_GRAVUR[m];
      if (m === 'blume') { c.rueck_monat = geburtsMonat() || 4; c.rueck_blume = blumeAktuell(); }
      if (m === 'sternenhimmel' || m === 'koordinaten') c.rueck_ort = state.rueckOrt || (vorschau ? BEISPIEL_ORT : null);
      if (m === 'sternenhimmel') {
        const datum = state.geburt.datum && !geburtProblem() ? state.geburt.datum : (vorschau ? BEISPIEL_DATUM : state.geburt.datum);
        c.geburt = { datum, zeit: state.geburt.zeit || null };
      }
      return c;
    }
    function rueckVorschauSVG() {
      const m = state.rueckMotiv;
      if (m === 'blume' && typeof window.jewelryBlumenFrontSVG !== 'function') return window.jewelryAbdruckBackSVG({ form: FORM, rueck_motiv: 'keine' });
      const extra = RUECK_PFAD.indexOf(m) >= 0 ? { d: (SP.beispiele || {})[m] || '' } : (SP.sterne || {});
      return window.jewelryAbdruckBackSVG(rueckCfg(true), extra);
    }

    /* ---------------- Bühne in der Galerie (besties-shirt.js stageEl/activeSlide/mountStageInGallery) ---------------- */
    function stageEl() {
      const alle = document.querySelectorAll('[data-apdp-stage]');
      for (let i = 1; i < alle.length; i++) alle[i].remove();
      return alle[0] || null;
    }
    function activeSlide() {
      const media = (VARIANTEN[varianteId()] || {}).media;
      return (media && document.querySelector('.product-gallery__media[data-media-id="' + media + '"]'))
        || document.querySelector('.product-gallery__media[data-variant-media="true"]')
        || document.querySelector('.product-gallery__media');
    }
    let galerieVersuche = 0;
    function mountStageInGallery() {
      const st = stageEl();
      const slide = activeSlide();
      if (!st) return;
      if (!slide) { if (galerieVersuche++ < 20) setTimeout(mountStageInGallery, 250); else galerieVersuche = 0; return; }
      galerieVersuche = 0;
      if (st.parentNode !== slide) {
        const alt = document.querySelector('.product-gallery__media.apdp-slide');
        if (alt && alt !== slide) alt.classList.remove('apdp-slide');
        slide.classList.add('apdp-slide');
        slide.appendChild(st);
      }
      const gal = slide.closest('.product-gallery');
      if (gal) { gal.classList.add('apdp-galerie-fixiert'); stickyEndeStarten(gal); }
      const scroller = slide.closest('.product-gallery__carousel');
      if (scroller) scroller.scrollLeft = 0;
    }

    /* Mobil (Dominik 23.10.): Die klebende Galerie soll nur bis zur Statuszeile („Fertig gestaltet“) kleben. Sobald die
       Zeile unter die Leiste rutschen würde, wird die Leiste um genau diesen Überhang nach oben geschoben und scrollt
       so natürlich mit dem Inhalt weg; beim Hochscrollen kommt sie genauso zurück. Das ist das Verhalten eines
       sticky-Elements am Ende seines Containers, nur dass der Container hier die ganze Buy Box ist. */
    /* 25.10.2026 (Dominik: Leiste wackelt beim Scrollen, je schneller, desto mehr): statt eines Scroll-Handlers, der
       Safari hinterherlief, klebt die Galerie in einem Rahmen (.apdp-sticky-rahmen), der genau bis 8 px ueber die
       Statuszeile reicht; der Browser loest sie dort selbst. Gerechnet wird nur bei Groessenaenderung. Gleiches
       Verfahren wie schmuck-pdp.js. */
    let stickyEndeAktiv = false;
    function stickyEndeStarten(gal) {
      if (stickyEndeAktiv) return;
      stickyEndeAktiv = true;
      const mq = window.matchMedia('(max-width: 999px)');
      let rahmen = gal.parentElement && gal.parentElement.classList.contains('apdp-sticky-rahmen') ? gal.parentElement : null;
      if (!rahmen) {
        rahmen = document.createElement('div');
        rahmen.className = 'apdp-sticky-rahmen';
        gal.parentNode.insertBefore(rahmen, gal);
        rahmen.appendChild(gal);
      }
      let tick = false;
      const rechnen = () => {
        tick = false;
        const status = document.querySelector('[data-apdp-status]');
        if (!mq.matches || !status || !gal.classList.contains('apdp-galerie-fixiert')) { rahmen.style.height = ''; rahmen.style.marginBottom = ''; return; }
        const h = Math.round(status.getBoundingClientRect().top - 8 - rahmen.getBoundingClientRect().top);
        const g = gal.offsetHeight;
        if (h > g) { rahmen.style.height = h + 'px'; rahmen.style.marginBottom = (g - h) + 'px'; }
        else { rahmen.style.height = ''; rahmen.style.marginBottom = ''; }
      };
      const anfordern = () => { if (!tick) { tick = true; requestAnimationFrame(rechnen); } };
      window.addEventListener('resize', anfordern);
      if (mq.addEventListener) mq.addEventListener('change', anfordern);
      if (typeof ResizeObserver === 'function') {
        const ro = new ResizeObserver(anfordern);
        ro.observe(gal);
        ro.observe(document.querySelector('.product-info') || document.body);
      }
      anfordern();
    }

    /* ---------------- Vorschau: 3D-Bühne der Konfiguratoren ----------------
       Dominik 20.10.: in der Galerie die Kette wie auf /pages/fussabdruck-kette-gestalten (Kette, Öse, Anhänger).
       Die Bühne entsteht erst, wenn der Träger in der Galerie hängt (vorher hat er keine Größe), und lebt auf window:
       der Neuaufbau der Buy Box lässt die Galerie stehen. Gravur = die Engine-SVGs mit literal '#000', die Bühne
       färbt selbst (setzeGravur), Farbe über setzeMaterial, Seite über rotateToSide (Ziehen dreht frei). */
    function buehne() {
      const st = stageEl();
      const host = st && st.querySelector('[data-apdp-3d]');
      if (!host || !host.closest('.product-gallery__media')) return null;
      if (SP.buehne && SP.buehneHost === host) return SP.buehne;
      if (!window.DLAbdruckBuehne) return null;          /* Modul noch nicht geladen: 'dl-abdruck-buehne-bereit' holt nach */
      host.innerHTML = '';
      /* blick: im quadratischen Galeriebild Kamera weiter weg als im Konfigurator (dort dz 1.1 / dy -0.45),
         verglichen 20.10.2026 an dz 2.4 / 3.2 / 4.0: 2.4 zeigt Anhänger ganz, Öse und Kette, Platz für die Umschalter. */
      SP.buehne = window.DLAbdruckBuehne.erstelle(host, { hdrUrl: CFG.hdrUrl, farbe: farbe(), aktiveSeite: () => SP.state.seite, blick: { dz: 2.4, dy: -0.15 } });
      SP.buehneHost = host;
      SP.buehneStand = { front: '', back: '', farbe: farbe(), seite: 'front' };
      if (typeof ResizeObserver === 'function') new ResizeObserver(() => SP.buehne && SP.buehne.resize()).observe(host);
      SP.buehne.resize();
      return SP.buehne;
    }
    function zeichnen() {
      const st = stageEl();
      if (!st) return;
      const hinweis = st.querySelector('.apdp-stage__hinweis');
      if (hinweis) {
        const m = state.rueckMotiv;
        hinweis.textContent = state.seite !== 'back' ? 'Beispiel-Fuß. Deinen Abdruck gestalten wir aus deinem Foto.'
          : RUECK_PFAD.indexOf(m) >= 0 ? 'Beispiel. Deine Rückseite gestalten wir aus deinem Foto.'
            : m === 'keine' ? 'Rückseite ohne Gravur.' : 'So wird deine Rückseite graviert.';
      }
      const bu = buehne();
      if (!bu) return;
      let front, back;
      try {
        const b = bogenTexte();
        const leer = !b.oben && !b.unten;
        const ring = leer || geburtProblem() ? BEISPIEL_BOGEN : b;
        front = window.jewelryAbdruckFrontSVG({ form: FORM, schrift: state.schrift, bogen_oben: ring.oben, bogen_unten: ring.unten }, state.beispielD);
        back = rueckVorschauSVG();
      } catch (e) { console.warn('[abdruck-pdp] Vorschau', e); return; }
      const stand = SP.buehneStand;
      if (stand.front !== front) { stand.front = front; bu.setzeGravur('front', front); }
      if (stand.back !== back) { stand.back = back; bu.setzeGravur('back', back); }
      const f = farbe();
      if (stand.farbe !== f) { stand.farbe = f; bu.setzeMaterial(f); }
      if (stand.seite !== state.seite) { stand.seite = state.seite; bu.rotateToSide(state.seite === 'back'); }
      if (!bu.modus3d) bu.fallbackZeige(state.seite);
    }

    /* ---------------- UI-Zustand ---------------- */
    function hinweisSetzen(el, standard, problem) {
      if (!el) return;
      el.textContent = problem || standard;
      el.classList.toggle('ist-fehler', !!problem);
    }
    const geburtHilfe = $('[data-apdp-geburt-hilfe]');
    const geburtStandard = geburtHilfe.textContent;
    function markiereFehler(scrollen) {
      state.fehlerAktiv = true;
      const keys = fehlendeFelder();
      let erster = null;
      root.querySelectorAll('[data-feld]').forEach((el) => {
        const fehlt = keys.indexOf(el.dataset.feld) !== -1 && el.offsetParent !== null;
        el.classList.toggle('apdp-field--fehlt', fehlt);
        let h = el.querySelector('.apdp-feld-hinweis');
        if (fehlt && !h) {
          h = document.createElement('span');
          h.className = 'apdp-feld-hinweis';
          h.textContent = 'Dieses Feld wird benötigt';
          const label = el.querySelector('.apdp-field__label');
          if (label) label.appendChild(h);
        } else if (!fehlt && h) h.remove();
        if (fehlt && !erster) erster = el;
      });
      if (scrollen && erster) erster.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function uiAktualisieren() {
      root.querySelectorAll('[data-apdp-start]').forEach((b) => {
        const an = b.dataset.apdpStart === state.start;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
      const rest = $('[data-apdp-rest]');
      rest.hidden = !state.start;
      if (state.start) rest.dataset.start = state.start;
      kachelBox.querySelectorAll('.apdp-schrift').forEach((b) => {
        const an = b.dataset.schrift === state.schrift;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
      /* Leere Felder der Dreier-Zeile nennt die Hilfezeile darunter, in den schmalen Spalten ist kein Platz für den Hinweis */
      const namen = { zeit: 'Uhrzeit', gewicht: 'Gewicht', groesse: 'Größe' };
      const leer = state.fehlerAktiv ? Object.keys(namen).filter((k) => state.geburt[k] === '').map((k) => namen[k]) : [];
      const leerText = leer.length ? 'Bitte noch ' + (leer.length > 1 ? leer.slice(0, -1).join(', ') + ' und ' + leer[leer.length - 1] : leer[0]) + ' eintragen.' : null;
      hinweisSetzen(geburtHilfe, geburtStandard, leerText || geburtProblem());
      const pr = rueckProblem();
      const fehlerEl = $('[data-apdp-error]');
      fehlerEl.textContent = pr || '';
      fehlerEl.hidden = !pr;
      fotoUi();
      rueckUi();
      const setHaken = $('[data-apdp-set]');
      if (setHaken) {
        setHaken.checked = state.set;
        setHaken.closest('.apdp-set').classList.toggle('is-active', state.set);
      }
      $('[data-apdp-set-hilfe]').textContent = mitSet()
        ? 'Das Set kommt zuerst. Den Link zum Hochladen bekommst du mit deiner Bestellung.'
        : 'Ohne Set machst du den Abdruck selbst, zum Beispiel mit Stempelkissen auf weißem Papier. Den Link zum Hochladen bekommst du mit deiner Bestellung.';
      const ok = fehlendeFelder().length === 0;
      const status = $('[data-apdp-status]');
      status.textContent = ok ? 'Gestaltet' : 'Noch nicht gestaltet';
      status.classList.toggle('is-ok', ok);
      if (state.fehlerAktiv) markiereFehler(false);
    }
    let zeichenTimer = null;
    function geaendert() {
      state.vorbereitet = null;
      uiAktualisieren();
      clearTimeout(zeichenTimer);
      zeichenTimer = setTimeout(zeichnen, 100);
    }

    /* ---------------- Eingaben ---------------- */
    const mitSet = () => state.start === 'nein' && state.set && !!CFG.setVariante;
    const setHakenEl = $('[data-apdp-set]');
    if (setHakenEl) setHakenEl.addEventListener('change', () => { state.set = setHakenEl.checked; geaendert(); });
    root.querySelectorAll('[data-apdp-start]').forEach((b) => b.addEventListener('click', () => {
      state.start = b.dataset.apdpStart;
      mountStageInGallery();
      geaendert();
    }));
    const felder = { datum: '#apdp-datum', zeit: '#apdp-zeit', gewicht: '#apdp-gewicht', groesse: '#apdp-groesse' };
    $('#apdp-datum').max = new Date().toISOString().slice(0, 10);
    for (const [k, sel] of Object.entries(felder)) {
      const el = $(sel);
      el.value = state.geburt[k] || '';
      const lesen = () => {
        if (k === 'gewicht' || k === 'groesse') el.value = el.value.replace(/\D/g, '');
        state.geburt[k] = el.value;
        if (state.seite !== 'front') state.seite = 'front';
        geaendert();
      };
      el.addEventListener('input', lesen);
      el.addEventListener('change', lesen);
    }
    /* ---------------- Rückseite: Kacheln und Detailfelder ---------------- */
    const motivBox = $('[data-apdp-motive]');
    for (const [k, label] of RUECK_KACHELN) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'apdp-motiv';
      b.setAttribute('role', 'radio');
      b.dataset.motiv = k;
      b.textContent = label;
      b.addEventListener('click', () => {
        state.rueckMotiv = k;
        state.seite = k === 'keine' ? 'front' : 'back';
        motivVorbereiten(k);
        geaendert();
        if (k === 'text') { const t = $('#apdp-rueck'); if (t && !t.value) t.focus({ preventScroll: true }); }
      });
      motivBox.appendChild(b);
    }
    const rueckEl = $('#apdp-rueck');
    rueckEl.value = state.rueck;
    rueckEl.addEventListener('input', () => { state.rueck = rueckEl.value; state.seite = 'back'; geaendert(); });
    rueckEl.addEventListener('focus', () => { if (state.seite !== 'back') { state.seite = 'back'; zeichnen(); } });
    const blumenBox = $('[data-apdp-blumen]');
    let blumenStand = '';
    function blumenUi() {
      const liste = blumenListe();
      const akt = blumeAktuell();
      const stand = liste.join(',');
      if (stand !== blumenStand) {
        blumenStand = stand;
        blumenBox.innerHTML = '';
        const motive = window.jewelryBlumenMotive || {};
        for (const k of liste) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'apdp-blume';
          b.setAttribute('role', 'radio');
          b.dataset.blume = k;
          b.innerHTML = (typeof window.jewelryBlumenMotivVorschauSVG === 'function' ? window.jewelryBlumenMotivVorschauSVG(k, 56) : '') + '<span class="apdp-blume__name"></span>';
          b.lastChild.textContent = (motive[k] && motive[k].label) || k;
          b.addEventListener('click', () => { state.rueckBlume = k; state.seite = 'back'; geaendert(); });
          blumenBox.appendChild(b);
        }
      }
      blumenBox.querySelectorAll('.apdp-blume').forEach((b) => {
        const an = b.dataset.blume === akt;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
      const hilfe = $('[data-apdp-blumen-hilfe]');
      hilfe.textContent = !liste.length ? 'Die Blumen laden …'
        : geburtsMonat() ? 'Zwei Blumen gehören zu deinem Geburtsmonat, such dir eine aus.'
          : 'Trag oben das Geburtsdatum ein, dann zeigen wir die Blumen deines Monats.';
    }
    function rueckFotoUi() {
      const m = state.rueckMotiv;
      if (RUECK_PFAD.indexOf(m) < 0) return;
      $('[data-apdp-rfoto-label]').textContent = m === 'handschrift' ? 'Foto deiner Handschrift (optional)' : 'Foto vom Fingerabdruck (optional)';
      const f = state.rueckFoto;
      $('[data-apdp-rfoto-upload]').hidden = !!f;
      $('[data-apdp-rfoto-status]').hidden = !f;
      const hilfe = $('[data-apdp-rfoto-hilfe]');
      const standard = m === 'handschrift'
        ? 'Schreib mit dunklem Stift auf weißes Papier und fotografier es von oben. Du kannst das Foto auch nach dem Kauf über den Link hochladen.'
        : (state.start === 'nein' && mitSet() ? 'Mit dem Abdruck-Set machst du auch den Fingerabdruck. Den Link zum Hochladen bekommst du mit deiner Bestellung.'
          : 'Du kannst das Foto auch nach dem Kauf über den Link hochladen, den du mit deiner Bestellung bekommst.');
      if (!f) { hinweisSetzen(hilfe, standard, null); return; }
      const name = $('[data-apdp-rfoto-name]');
      if (!f.fertig) { name.textContent = 'Foto wird hochgeladen …'; hinweisSetzen(hilfe, standard, null); }
      else if (f.url) { name.textContent = '✓ ' + f.name; hinweisSetzen(hilfe, 'Foto ist da. Wir bereiten es für die Gravur vor.', null); }
      else { name.textContent = f.name; hinweisSetzen(hilfe, '', 'Das Foto konnte nicht hochgeladen werden. Bitte entfernen und noch einmal versuchen.'); }
    }
    function ortUi() {
      const m = state.rueckMotiv;
      if (m !== 'sternenhimmel' && m !== 'koordinaten') return;
      const hilfe = $('[data-apdp-ort-hilfe]');
      if (!state.rueckOrt) { hinweisSetzen(hilfe, m === 'sternenhimmel' ? 'Der Himmel über diesem Ort zur Geburtsstunde.' : 'Wir gravieren Breiten- und Längengrad.', null); return; }
      const z = window.jewelryAbdruckKoordZeilen ? window.jewelryAbdruckKoordZeilen(state.rueckOrt).join(' · ') : '';
      hinweisSetzen(hilfe, (m === 'sternenhimmel' ? 'Himmel über ' + state.rueckOrt.name + ' (' + z + ').' : z), null);
    }
    function rueckUi() {
      const m = state.rueckMotiv;
      motivBox.querySelectorAll('.apdp-motiv').forEach((b) => {
        const an = b.dataset.motiv === m;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
      const art = m === 'text' ? 'text' : RUECK_PFAD.indexOf(m) >= 0 ? 'pfad' : m === 'blume' ? 'blume'
        : (m === 'sternenhimmel' || m === 'koordinaten') ? 'ort' : '';
      root.querySelectorAll('[data-motiv-feld]').forEach((el) => { el.hidden = el.dataset.motivFeld !== art; });
      $('[data-apdp-zaehler]').textContent = rueckZeichen() + '/' + RUECK_MAX;
      if (art === 'blume') blumenUi();
      rueckFotoUi();
      ortUi();
    }

    /* Foto der Rückseite: gleicher Upload wie vorne, optional */
    const rfotoInput = $('#apdp-rfoto');
    rfotoInput.addEventListener('change', () => {
      const file = rfotoInput.files && rfotoInput.files[0];
      rfotoInput.value = '';
      if (!file) return;
      const hilfe = $('[data-apdp-rfoto-hilfe]');
      if (!/^image\/(jpeg|png)$/.test(file.type)) { hinweisSetzen(hilfe, '', 'Bitte ein Foto als JPG oder PNG wählen.'); return; }
      if (file.size > MAX_DATEI_MB * 1024 * 1024) { hinweisSetzen(hilfe, '', 'Das Foto ist größer als ' + MAX_DATEI_MB + ' MB.'); return; }
      const eintrag = { name: file.name, url: null, fertig: false, lauf: null };
      eintrag.lauf = (async () => {
        let url = null;
        try { const blob = await fotoAlsJpeg(file); url = await mitBudget((sig) => presignedUpload(blob, 'abdruck-rueck-foto.jpg', 'image/jpeg', sig), FOTO_LAUF_MS); }
        catch (e) { url = null; }
        eintrag.url = url || null;
        eintrag.fertig = true;
        if (state.rueckFoto === eintrag && SP.inst) SP.inst.geaendert();
        return eintrag.url;
      })();
      state.rueckFoto = eintrag;
      geaendert();
    });
    $('[data-apdp-rfoto-weg]').addEventListener('click', () => { state.rueckFoto = null; geaendert(); });

    /* Ortssuche: Mapbox-Geocoding wie die Sternenkette (assets/jewelry.js), Treffer muss gewählt werden */
    const ortInput = $('#apdp-ort');
    const ortTreffer = $('[data-apdp-ort-treffer]');
    if (state.rueckOrt) ortInput.value = state.rueckOrt.name;
    let geoT = null, geoAbbruch = null;
    ortInput.addEventListener('input', () => {
      clearTimeout(geoT);
      if (state.rueckOrt && ortInput.value.trim() !== state.rueckOrt.name) { state.rueckOrt = null; geaendert(); }
      const q = ortInput.value.trim();
      if (q.length < 2) { ortTreffer.hidden = true; return; }
      geoT = setTimeout(async () => {
        try {
          if (geoAbbruch) geoAbbruch.abort();
          geoAbbruch = new AbortController();
          const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(q) + '.json'
            + '?access_token=' + CFG.mapboxToken + '&limit=5&language=de&types=' + 'place,locality,neighborhood,address,poi';
          const d = await (await fetch(url, { signal: geoAbbruch.signal })).json();
          const hits = (d.features || []).map((f) => ({ name: ortLabel(f), voll: f.place_name, lat: f.center[1], lon: f.center[0] }));
          ortTreffer.innerHTML = '';
          hits.forEach((o) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'apdp-ort__eintrag';
            b.innerHTML = '<span class="apdp-ort__name"></span><span class="apdp-ort__voll"></span>';
            b.firstChild.textContent = o.name;
            b.lastChild.textContent = o.voll;
            b.addEventListener('click', () => {
              state.rueckOrt = { name: o.name, lat: o.lat, lon: o.lon };
              ortInput.value = o.name;
              ortTreffer.hidden = true;
              state.seite = 'back';
              geaendert();
            });
            ortTreffer.appendChild(b);
          });
          ortTreffer.hidden = !hits.length;
        } catch (e) { /* Abbruch/Netz: Liste bleibt, wie sie ist */ }
      }, 300);
    });
    ortInput.addEventListener('blur', () => setTimeout(() => {
      ortTreffer.hidden = true;
      if (state.rueckOrt && ortInput.value.trim() !== state.rueckOrt.name) ortInput.value = state.rueckOrt.name;
    }, 200));
    if (state.rueckMotiv !== 'keine') motivVorbereiten(state.rueckMotiv);

    /* ---------------- Foto (optional bei Nein, Pflicht bei Ja; nie in der Vorschau) ---------------- */
    async function presignedUpload(blob, dateiname, contentType, signal) {
      const r = await fetch(API + '/api/v1/upload/presigned-url/', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: dateiname, contentType, folder: 'gravur' }), signal,
      });
      if (!r.ok) throw new Error('Upload-URL konnte nicht abgerufen werden');
      const p = await r.json();
      if (!p.success) throw new Error(p.error || 'Upload-URL konnte nicht abgerufen werden');
      const fd = new FormData();
      Object.keys(p.fields || {}).forEach((k) => fd.append(k, p.fields[k]));
      fd.append('file', blob, dateiname);
      const u = await fetch(p.uploadUrl, { method: 'POST', body: fd, signal });
      if (u.status !== 200 && u.status !== 204) throw new Error('Upload fehlgeschlagen mit Status ' + u.status);
      return p.publicUrl;
    }
    async function mitBudget(fn, ms) {
      const abbruch = new AbortController();
      let timer = null;
      try {
        const lauf = fn(abbruch.signal);
        lauf.catch(() => {});
        return await Promise.race([lauf, new Promise((res) => { timer = setTimeout(() => { abbruch.abort(); res(null); }, ms); })]);
      } catch (e) { return null; } finally { clearTimeout(timer); }
    }
    async function fotoAlsJpeg(file) {
      let q, w, h;
      try { q = await createImageBitmap(file, { imageOrientation: 'from-image' }); w = q.width; h = q.height; }
      catch (e) {
        q = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file); });
        w = q.naturalWidth; h = q.naturalHeight;
      }
      const f = Math.min(1, FOTO_MAX / Math.max(w, h));
      const c = Object.assign(document.createElement('canvas'), { width: Math.round(w * f), height: Math.round(h * f) });
      const ctx = c.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(q, 0, 0, c.width, c.height);
      return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob leer'))), 'image/jpeg', 0.9));
    }
    const fotoHilfe = $('[data-apdp-foto-hilfe]');
    const fotoHilfeStandard = fotoHilfe.textContent;
    function fotoUi() {
      const f = state.foto;
      $('[data-apdp-upload]').hidden = !!f;
      $('[data-apdp-foto-status]').hidden = !f;
      if (!f) { hinweisSetzen(fotoHilfe, fotoHilfeStandard, null); return; }
      const name = $('[data-apdp-foto-name]');
      if (!f.fertig) { name.textContent = 'Foto wird hochgeladen …'; hinweisSetzen(fotoHilfe, fotoHilfeStandard, null); }
      else if (f.url) { name.textContent = '✓ ' + f.name; hinweisSetzen(fotoHilfe, 'Foto ist da. Wir bereiten deinen Abdruck für die Gravur vor.', null); }
      else { name.textContent = f.name; hinweisSetzen(fotoHilfe, '', 'Das Foto konnte nicht hochgeladen werden. Bitte entfernen und noch einmal versuchen.'); }
    }
    const fotoInput = $('#apdp-foto');
    fotoInput.addEventListener('change', () => {
      const file = fotoInput.files && fotoInput.files[0];
      fotoInput.value = '';
      if (!file) return;
      if (!/^image\/(jpeg|png)$/.test(file.type)) { hinweisSetzen(fotoHilfe, '', 'Bitte ein Foto als JPG oder PNG wählen.'); return; }
      if (file.size > MAX_DATEI_MB * 1024 * 1024) { hinweisSetzen(fotoHilfe, '', 'Das Foto ist größer als ' + MAX_DATEI_MB + ' MB.'); return; }
      const eintrag = { name: file.name, url: null, fertig: false, lauf: null };
      eintrag.lauf = (async () => {
        let url = null;
        try { const blob = await fotoAlsJpeg(file); url = await mitBudget((sig) => presignedUpload(blob, 'abdruck-foto.jpg', 'image/jpeg', sig), FOTO_LAUF_MS); }
        catch (e) { url = null; }
        eintrag.url = url || null;
        eintrag.fertig = true;
        if (state.foto === eintrag && SP.inst) SP.inst.geaendert();
        return eintrag.url;
      })();
      state.foto = eintrag;
      geaendert();
    });
    $('[data-apdp-foto-weg]').addEventListener('click', () => { state.foto = null; geaendert(); });

    /* ---------------- Kauf über das Theme-Formular ---------------- */
    function svgZuImage(svg) {
      return new Promise((res, rej) => {
        const img = new Image();
        img.onload = () => res(img);
        img.onerror = () => rej(new Error('SVG-Raster fehlgeschlagen'));
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
      });
    }
    /* Warenkorb-Bild: Coin-Variante 1:1 aus jewelry-abdruck.js vorschauBlob, mit dem Beispiel-Fuß */
    async function vorschauBlob(f, frontSvg) {
      const S = 480;
      const c = Object.assign(document.createElement('canvas'), { width: S, height: S });
      const ctx = c.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, S, S);
      const [hell, dunkel] = f === 'gold' ? ['#EDD9A3', '#C9A24B'] : ['#F2F3F4', '#C7C9CC'];
      const img = await svgZuImage(frontSvg);
      const r = S * 0.46;
      const grad = ctx.createRadialGradient(S * 0.35, S * 0.30, r * 0.1, S / 2, S / 2, r);
      grad.addColorStop(0, hell);
      grad.addColorStop(1, dunkel);
      ctx.beginPath(); ctx.arc(S / 2, S / 2, r, 0, Math.PI * 2); ctx.fillStyle = grad; ctx.fill();
      const D = S * 0.84;
      ctx.save(); ctx.beginPath(); ctx.arc(S / 2, S / 2, D / 2, 0, Math.PI * 2); ctx.clip();
      ctx.drawImage(img, (S - D) / 2, (S - D) / 2, D, D);
      ctx.restore();
      return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob leer'))), 'image/jpeg', 0.85));
    }
    const signatur = () => JSON.stringify([state.start, mitSet(), state.schrift, state.geburt, rueckCfg(false), state.rueckFoto && state.rueckFoto.url, state.foto && state.foto.url, varianteId()]);
    /* Klartext der Rückseite für Warenkorb, Bestellung und Werkstatt */
    function rueckBeschreibung(c, rueckFotoUrl) {
      const m = c.rueck_motiv;
      if (m === 'keine') return 'keine';
      if (m === 'text') return 'Text: ' + c.rueckseite.split('\n').join(' / ');
      if (RUECK_PFAD.indexOf(m) >= 0) return (m === 'handschrift' ? 'Handschrift' : 'Fingerabdruck') + (rueckFotoUrl ? ', Foto hochgeladen' : ', Upload-Link folgt');
      if (m === 'blume') {
        const mo = (window.jewelryBlumenMotive || {})[c.rueck_blume];
        return 'Geburtsblume: ' + ((mo && mo.label) || c.rueck_blume);
      }
      const z = window.jewelryAbdruckKoordZeilen(c.rueck_ort).join(' ');
      return (m === 'sternenhimmel' ? 'Sternenhimmel: ' : 'Koordinaten: ') + c.rueck_ort.name + ' (' + z + ')';
    }
    function knopfSperren(f, an) {
      f.querySelectorAll('[type="submit"]').forEach((b) => { b.disabled = an; b.toggleAttribute('aria-busy', an); });
    }
    async function vorbereitenUndSenden(f, submitter) {
      knopfSperren(f, true);
      try {
        let fotoUrl = null;
        if (state.foto) {
          fotoUrl = await Promise.race([state.foto.lauf, new Promise((r) => setTimeout(() => r(null), FOTO_WARTEN_MS))]);
          if (!fotoUrl) { uiAktualisieren(); markiereFehler(true); return; }
        }
        const rc = rueckCfg(false);
        let rueckFotoUrl = null;
        if (RUECK_PFAD.indexOf(rc.rueck_motiv) >= 0 && state.rueckFoto) {
          rueckFotoUrl = await Promise.race([state.rueckFoto.lauf, new Promise((r) => setTimeout(() => r(null), FOTO_WARTEN_MS))]);
          if (!rueckFotoUrl) { uiAktualisieren(); markiereFehler(true); return; }
        }
        if (rc.rueck_motiv === 'blume' && !rc.rueck_blume) {
          const fe = $('[data-apdp-error]');
          fe.textContent = 'Die Blumen sind noch nicht geladen. Bitte versuch es gleich noch einmal.';
          fe.hidden = false;
          return;
        }
        const fb = farbe();
        const b = bogenTexte();
        const g = state.geburt;
        const cfg = {
          produkt: FORM === 'herz' ? 'abdruck-herz' : 'abdruck-coin', version: 2, quelle: 'pdp',
          motiv: CFG.motiv || 'fussabdruck', gravur: ENGINE.GRAVUR_FLAECHE, layout: 'eins', form: FORM,
          farbe: fb, schrift: state.schrift, rueckseite: rc.rueckseite || '', rueck_modus: 'freitext', rueck_name: '',
          rueck_motiv: rc.rueck_motiv,
          rueck_bogen_oben: '', rueck_bogen_unten: '', bogen_oben: b.oben, bogen_unten: b.unten,
          geburt: { datum: g.datum || '', zeit: g.zeit || '', gewicht: g.gewicht === '' ? null : parseInt(g.gewicht, 10), groesse: g.groesse === '' ? null : parseInt(g.groesse, 10) },
          abdruck: 'ausstehend', pfad_url: null, foto_url: fotoUrl, foto2_url: null,
          start: state.start,
        };
        if (rc.rueck_gravur) Object.assign(cfg, { rueck_gravur: rc.rueck_gravur, rueck_abdruck: 'ausstehend', rueck_pfad_url: null, rueck_foto_url: rueckFotoUrl });
        if (rc.rueck_motiv === 'blume') Object.assign(cfg, { rueck_monat: rc.rueck_monat, rueck_blume: rc.rueck_blume });
        if (rc.rueck_ort) cfg.rueck_ort = { name: rc.rueck_ort.name, lat: rc.rueck_ort.lat, lon: rc.rueck_ort.lon };
        setProp(f, '_Motiv', 'Fußabdruck');
        setProp(f, '_Schrift', schriftLabel(state.schrift));
        setProp(f, '_Geburtsdaten', [b.oben, b.unten].filter(Boolean).join(' / '));
        setProp(f, '_Rueckseite', rueckBeschreibung(rc, rueckFotoUrl));
        setProp(f, '_Schmuckfarbe', fb === 'gold' ? 'Gold' : 'Silber');
        setProp(f, '_Abdruck', fotoUrl ? 'Foto hochgeladen' : (mitSet() ? 'Abdruck-Set zuerst, Upload-Link folgt' : 'Kunde macht den Abdruck selbst, Upload-Link folgt'));
        setProp(f, '_Provider', 'inhouse');
        setProp(f, '_editor_url', editorUrl());
        setProp(f, '_config_json', JSON.stringify(cfg));
        const frontSvg = window.jewelryAbdruckFrontSVG({ form: FORM, schrift: state.schrift, bogen_oben: b.oben, bogen_unten: b.unten }, state.beispielD);
        const vorschau = await mitBudget(async (sig) => presignedUpload(await vorschauBlob(fb, frontSvg), 'abdruck-preview.jpg', 'image/jpeg', sig), VORSCHAU_MS);
        setProp(f, '_preview_image_url', vorschau || '');
        /* Set als eigene Position VOR der Kette: das Theme legt danach die Kette per AJAX ab und lädt den Drawer neu,
           der dann beide Zeilen zeigt. Liegt schon ein Set im Warenkorb, kein zweites. */
        if (mitSet()) {
          const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()).catch(() => null);
          const schonDa = cart && (cart.items || []).some((it) => String(it.variant_id) === String(CFG.setVariante));
          if (!schonDa) {
            const r = await fetch('/cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: CFG.setVariante, quantity: 1 }] }),
            }).catch(() => null);
            if (!r || !r.ok) {
              const fe = $('[data-apdp-error]');
              fe.textContent = 'Das Abdruck-Set ließ sich gerade nicht hinzufügen. Bitte versuch es noch einmal.';
              fe.hidden = false;
              return;
            }
          }
        }
        state.vorbereitet = signatur();
      } finally {
        knopfSperren(f, false);
      }
      if (state.vorbereitet !== signatur()) return;
      /* PROJ-99 Bearbeiten-Modus: selbst einlegen (das Theme-Formular gibt die Antwort nicht heraus), DANN die alte
         Zeile über cart-edit.js entfernen. Andersherum wäre der Warenkorb im Fehlerfall leer. */
      if (SP.bearbeiten && window.DLCartEdit) {
        knopfSperren(f, true);
        try {
          const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(f) });
          if (!r.ok) throw new Error('add.js HTTP ' + r.status);
          const antwort = await r.json();
          const ok = await window.DLCartEdit.abschliessen(antwort);
          SP.bearbeiten = false;
          if (!ok) return;
        } catch (e) {
          console.error('[abdruck-pdp] Bearbeiten', e);
          const fe = $('[data-apdp-error]');
          fe.textContent = 'Die Änderung ließ sich gerade nicht übernehmen. Bitte versuch es noch einmal.';
          fe.hidden = false;
        } finally {
          state.vorbereitet = null;
          knopfSperren(f, false);
        }
        return;
      }
      if (f.requestSubmit) f.requestSubmit(submitter && submitter.form === f ? submitter : undefined);
      else f.submit();
    }

    /* ---------------- Bearbeiten aus dem Warenkorb (PROJ-99, wie die Konfiguratoren) ----------------
       Die Zeile trägt _editor_url = diese Seite mit Farbe (?variant=) und auf Dev ?view=. Der Link „Bearbeiten“
       hängt ?edit=<Zeile> an; cart-edit.js (Layout) holt _config_json, jewelry-bearbeiten.js prüft Produkt und
       Version und ruft zustandAnwenden auf. Der nächste Klick auf den Theme-Knopf ersetzt die alte Zeile. */
    function editorUrl() {
      const q = new URLSearchParams();
      const view = new URLSearchParams(location.search).get('view');
      if (view) q.set('view', view);
      q.set('variant', varianteId());
      return location.pathname + '?' + q.toString();
    }
    function zahlText(v) { return v == null || v === '' ? '' : String(v); }
    async function zustandAnwenden(c) {
      const angewendet = [];
      state.start = c.start === 'ja' || c.start === 'nein' ? c.start : (c.foto_url ? 'ja' : 'nein');
      if (schriften.indexOf(c.schrift) >= 0) state.schrift = c.schrift;
      const g = c.geburt || {};
      state.geburt = { datum: g.datum || '', zeit: g.zeit || '', gewicht: zahlText(g.gewicht), groesse: zahlText(g.groesse) };
      state.rueckMotiv = RUECK_KACHELN.some((k) => k[0] === c.rueck_motiv) ? c.rueck_motiv : ((c.rueckseite || '').trim() ? 'text' : 'keine');
      state.rueck = c.rueckseite || '';
      state.rueckOrt = c.rueck_ort && isFinite(c.rueck_ort.lat) ? { name: c.rueck_ort.name, lat: c.rueck_ort.lat, lon: c.rueck_ort.lon } : null;
      state.rueckBlume = c.rueck_blume || '';
      const altFoto = (url) => (url ? { name: 'Foto aus deiner Bestellung', url, fertig: true, lauf: Promise.resolve(url) } : null);
      state.foto = altFoto(c.foto_url);
      state.rueckFoto = altFoto(c.rueck_foto_url);
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()).catch(() => null);
      state.set = !!(cart && CFG.setVariante && (cart.items || []).some((it) => String(it.variant_id) === String(CFG.setVariante)));
      for (const [k, sel] of Object.entries(felder)) $(sel).value = state.geburt[k];
      rueckEl.value = state.rueck;
      ortInput.value = state.rueckOrt ? state.rueckOrt.name : '';
      angewendet.push('start', 'schrift', 'geburt', 'rueckseite');
      mountStageInGallery();
      if (state.rueckMotiv !== 'keine') motivVorbereiten(state.rueckMotiv);
      geaendert();
      return { angewendet, fehlend: [] };
    }
    /* Die Seite hat zwei Formulare dieser Kette (gemessen 21.10.), nur eines trägt den Knopf */
    function themeKnopf() {
      for (const f of document.querySelectorAll('form[action*="/cart/add"]')) {
        const k = istUnserFormular(f) && f.querySelector('[type="submit"]');
        if (k) return k;
      }
      return null;
    }
    const BEARB = window.DLJewelryBearbeiten;
    if (BEARB && BEARB.istModus && !SP.bearbeitenGestartet) {
      SP.bearbeitenGestartet = true;
      BEARB.knopfSperren(themeKnopf());
      BEARB.starten({
        name: 'abdruck-pdp', produkt: FORM === 'herz' ? 'abdruck-herz' : 'abdruck-coin', version: 2,
        passt: (c) => (c.quelle === 'pdp' && c.motiv === (CFG.motiv || 'fussabdruck') ? null : 'nicht von dieser Produktseite'),
        anwenden: (c) => SP.inst.zustandAnwenden(c),
        knopf: themeKnopf(),
      }).then((ok) => {
        SP.bearbeiten = ok;
        /* Die Buy Box kann seit dem Sperren neu aufgebaut worden sein: Knopftext am aktuellen Knopf setzen */
        if (ok && window.DLCartEdit) window.DLCartEdit.knopfAnpassen(themeKnopf());
      });
    } else if (SP.bearbeiten && window.DLCartEdit) {
      /* Farbwechsel baut die Buy Box neu: der neue Knopf heißt wieder „Änderung übernehmen“ */
      window.DLCartEdit.knopfAnpassen(themeKnopf());
    }

    /* ---------------- Start (auch nach jedem Neuaufbau der Buy Box) ---------------- */
    /* Lauscher werden nur EINMAL registriert und rufen immer die aktuelle Instanz (nach Neuaufbau der Buy Box). */
    SP.inst = { geaendert, zeichnen, mountStageInGallery, markiereFehler, fehlendeFelder, vorbereitenUndSenden, signatur, zustandAnwenden };
    if (!SP.lauscher) {
      SP.lauscher = true;
      document.addEventListener('dl-abdruck-buehne-bereit', () => SP.inst && SP.inst.zeichnen());
      document.addEventListener('variant:change', () => setTimeout(() => {
        if (!SP.inst) return;
        if (SP.state.start) SP.inst.mountStageInGallery();
        SP.inst.zeichnen();
      }, 0));
      document.addEventListener('submit', (e) => {
        const f = e.target;
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || !istUnserFormular(f)) return;
        const I = SP.inst;
        if (!I) return;
        if (window.DLCartEdit && window.DLCartEdit.istGesperrt()) { e.preventDefault(); e.stopPropagation(); return; }
        if (I.fehlendeFelder().length) {
          e.preventDefault();
          e.stopPropagation();
          SP.state.fehlerAktiv = true;
          I.geaendert();
          I.markiereFehler(true);
          return;
        }
        if (SP.state.vorbereitet === I.signatur()) return;   /* zweiter Durchlauf: Theme legt in den Warenkorb */
        e.preventDefault();
        e.stopPropagation();
        I.vorbereitenUndSenden(f, e.submitter);
      }, true);
    }
    uiAktualisieren();
    if (state.start) mountStageInGallery();
    if (state.beispielD) zeichnen();
    else fetch(CFG.beispielUrl, { credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        const d = j && typeof j.d === 'string' ? j.d : '';
        if (d && window.jewelryAbdruckPfadOk(d).ok) state.beispielD = d;
        if (SP.inst) SP.inst.zeichnen();
      })
      .catch(() => {});
  }
  window.__dlAbdruckPdpStart = starte;
  new MutationObserver(starte).observe(document.body, { childList: true, subtree: true });
  starte();
})();
